export const awsConfigDev = {
  Auth: {
    Cognito: {
      region: "ap-south-1",
      userPoolId: "ap-south-1_05rnAA8hM",
      userPoolClientId: "5l9beaq1niaeg70jag9sd6u29a",
      loginMechanisms: ["username", "email"],
      oauth: {
        domain:
          "riddhi-dev-ap-south-1-349100327741.auth.ap-south-1.amazoncognito.com",
        scope: [
          "phone",
          "openid",
          "profile",
          "email",
          "api.crm.riddhi.co.in/admin",
          "api.crm.riddhi.co.in/read",
          "api.crm.riddhi.co.in/write",
          "aws.cognito.signin.user.admin",
        ],
        redirectSignIn: ["http://localhost:8080/"],
        redirectSignOut: ["http://localhost:8080/"],
        responseType: "code",
        apiEnv: "Dev",
      },
    },
  },
  Api: {
    ProvisionEndpoint:
      "https://s7g2gsczn2.execute-api.ap-south-1.amazonaws.com/Dev/api/v1/admin/provision/client",
    ClientsEndpoint:
      "https://s7g2gsczn2.execute-api.ap-south-1.amazonaws.com/Dev/api/v1/admin/clients",
    ClientGoalsEndpoint:
      "https://s7g2gsczn2.execute-api.ap-south-1.amazonaws.com/Dev/api/v1/admin/clients",
    ClientOwnGoalsEndpoint:
      "https://s7g2gsczn2.execute-api.ap-south-1.amazonaws.com/Dev/api/v1/client",
    ClientPlanningReviewsEndpoint:
      "https://s7g2gsczn2.execute-api.ap-south-1.amazonaws.com/Dev/api/v1/admin/clients",
    ClientAssetsEndpoint:
      "https://s7g2gsczn2.execute-api.ap-south-1.amazonaws.com/Dev/api/v1/admin/clients",
    HealthReportEndpoint:
      "https://s7g2gsczn2.execute-api.ap-south-1.amazonaws.com/Dev/api/v1/client/healthreport",
    RegistrationEndpoint:
      "https://s7g2gsczn2.execute-api.ap-south-1.amazonaws.com/Dev/api/v1/public/register",
  },
  HealthReport: {
    ApiKey: "hr_f267feb03cd043fab72014e0e06aa505", // Replace with actual dev API key
    RateLimit: {
      maxRequests: 10,
      windowMs: 60000, // 1 minute
    },
  },
  Registration: {
    ApiKey: "reg_a98bf8f63e9d411082240d48089bbf6d", // Dev API key
    RateLimit: {
      maxRequests: 20,
      windowMs: 60000, // 1 minute
    },
  },
  // federationDisabled: true,
};

console.log("AWS Config:", {
  region: process.env.VUE_APP_AWS_REGION,
  userPoolId: process.env.VUE_APP_USER_POOL_ID,
  clientId: process.env.VUE_APP_CLIENT_ID,
});

// export default awsConfig;
